export default __webpack_public_path__ + "static/media/feather_icon.333732e6.svg";